module.exports = __webpack_public_path__ + "static/home_item_c-62348bf752dc05941dd79ce67a0491d2.jpg";